(function () {
    /**
     * Prevent the document from scrolling whenever a modal has been opened.
     * @param {Event}
     */
    const onOverlayChange = ({ detail }) => {
        const { isOpen } = detail;
        document.documentElement.classList.toggle('no-scroll', isOpen);
    };

    document.addEventListener('modaloverlaychange', onOverlayChange);
    document.addEventListener('galleryoverlaychange', onOverlayChange);
})();



// WEBPACK FOOTER //
// ./scripts/custom/occasions/occasionOverlay.js